export function currentBreakpoint() {
    if ($(document).data('mediaQueryLabel') !== undefined) {
        return $(document).data('mediaQueryLabel').get();
    } else {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/web/js/app/utils/breakpoints.js